export const DEFAULT_CONDITION_TREE_FEATURE_FLAGS={IS_CTREE_EDITING_ALLOWED:false,IS_TESTING_VALIDITY_AREA_ALLOWED:true};